'use strict';

angular.module('dekky.forms')
.provider('formField', function() {

	this.$get = function($log, $injector) {
		function fieldFactory(name, fieldType, config, additionalParams) {
			fieldType = fieldType.charAt(0).toUpperCase() + fieldType.slice(1) + 'Field';

			var fieldTypeService = $injector.get(fieldType);

			return fieldTypeService(name, config, additionalParams);
		}

		return fieldFactory;
	};
});